var FCFieldsView = require('../fcFields/view');

module.exports = FCFieldsView.extend({
    onRender: function () {
        FCFieldsView.prototype.onRender.apply(this, arguments);
        this.$('.fcField').remove();  // TODO: this all from hack, could boost perf with diff template if continue this way
    }
});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/page/docNotes/view.js
 ** module id = 548
 ** module chunks = 0
 **/